import { Component } from '@angular/core';

@Component({
  selector: 'app-layout-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent {
  hoy = Date.now();
}



// WEBPACK FOOTER //
// ./src/app/componentes/layout/footer.component.ts